module.exports = __webpack_public_path__ + "static/media/icon-gift-solid.7d8a8307.svg";